import React from "react";
import Search from "../components/search.js";
import { Container, Row, Col } from "react-bootstrap";
import listinguser1 from '../assets/listinguser1.png';
import listinguser2 from '../assets/listinguser2.png';
import listinguser3 from '../assets/listinguser3.png';
import truck from '../assets/truck.png';
import varified from '../assets/varified.png';
import vendorlistingmap from '../style/vendorlistingmap.css';
import farmitem1 from '../assets/farmitem1.png';
import farmitem2 from '../assets/farmitem2.png';
import farmitem3 from '../assets/farmitem3.png';
import farmitem4 from '../assets/farmitem4.png';
import farmitem5 from '../assets/farmitem5.png';
import filtermap from '../assets/filtermap.png';
import { Link } from 'react-router-dom';

const vendorlistingwithmap = () => {

const vendors = [
  {
    id: 1,
    name: "R&B Rhyne Farm", 
    location: "Angier, North Carolina",
    image: listinguser1,
    products: [
      { id: 101, name: "Black Angus Ground", price: "$65.00/Unit", image: farmitem1 },
      { id: 102, name: "Beef Steak", price: "$70.00/Unit", image: farmitem2 },
      // aur products
    ],
  },
  {
    id: 2,
    name: "Acorn Acres Farmhouse",
    location: "Angier, North Carolina",
    image: listinguser2,
    products: [
      { id: 201, name: "Lamb Chops", price: "$80.00/Unit", image: farmitem3 },
      { id: 202, name: "Pork Belly", price: "$75.00/Unit", image: farmitem4 },
    ],
  },
];


  return (
    <div>
     <Search/>

<section className="farmsdetails">
  <Container>
    <Row>
      <Col md={7}>
     {vendors.map((vendor) => (
  <div className="filterimagetextleft" key={vendor.id}>
    <div className="teamssection">
      <div className="rhymefarmimg">
        <img src={vendor.image} />
      </div>
      <div className="rhymefarmtext">
        <ul>
          <li><img src={varified} />Verified</li>
          <li><img src={truck} />Delivery</li>
        </ul>
        <h4>{vendor.name}</h4>
        <p>{vendor.location}</p>
      </div>
    </div>

    <Row className="farmwrapper">
      {vendor.products.map((product) => (
        <Col md={3} key={product.id}>
          <Link to={`/product/${product.id}`}>
            <div className="farmitem">
              <img src={product.image} />
              <h6>{product.price}</h6>
              <h4>{product.name}</h4>
            </div>
          </Link>
        </Col>
      ))}
    </Row>
  </div>
))}

      </Col>
      <Col md={5}>
      <div className="filterimagefull">
        <img src={filtermap}/>
      </div>
      </Col>
    </Row>
  </Container>
</section>

     
    </div>
  );
};

export default vendorlistingwithmap;
